import { render, staticRenderFns } from "./blob_content_viewer.vue?vue&type=template&id=8b0ce9ac&scoped=true&vue3"
import script from "./blob_content_viewer.vue?vue&type=script&lang=js&vue3"
export * from "./blob_content_viewer.vue?vue&type=script&lang=js&vue3"
import style0 from "./blob_content_viewer.vue?vue&type=style&index=0&id=8b0ce9ac&prod&scoped=true&lang=css&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0ce9ac",
  null
  
)

export default component.exports